/**
 * AuthRequest
 * @author Simpli CLI generator
 */
import {$, Helper, Model, Request} from 'simpli-web-sdk'
import {ResponseExclude} from 'simpli-web-sdk'
import {AuthResponse} from '@/model/response/AuthResponse'
import {Env} from '@/helpers/Env'
import {InternationalRequest} from '@/helpers/InternationalRequest'

const sha1 = require('sha1')

/* TODO: review generated class */
export class AuthRequest extends Model {
  email: string | null = null

  @ResponseExclude()
  senha: string | null = null

  /**
   * Gets the user authentication
   */
  static async authenticate() {
    try {
      return await Request.get(`/admin/auth`)
        .name('authenticate')
        .as(AuthResponse)
        .getData()
    } catch {
      return await InternationalRequest.get(`/admin/auth`)
        .name('authenticate')
        .as(AuthResponse)
        .getData()
    }
  }

  /**
   * Submits the user authentication
   */
  async signIn() {
    const request = this.$clone()
    request.senha = sha1(this.senha ?? '')
    try {
      return await Request.post(`/admin/auth`, request)
        .name('signIn')
        .delay(1000)
        .as(AuthResponse)
        .getData()
    } catch {
      return await InternationalRequest.post(`/admin/auth`, request)
        .name('signIn')
        .delay(1000)
        .as(AuthResponse)
        .getData()
    }
  }

  static async getPainelClienteToken(idResp: number) {
    return await Request.get(`/admin/auth/me/generate-painel-token/${idResp}`)
      .name('getPainelClienteToken')
      .asString()
      .getData()
  }
}
